module.exports = __webpack_public_path__ + "img/logo_navbar.6b8d7508.png";